module.exports = {
      id: "comm-environment-usage",
      viewBox: "0 0 276.484 47.102",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#comm-environment",
      toString: function () {
        return this.url;
      }
    }